import CompanyRoomPage from './CompanyOfferPage';

export default CompanyRoomPage;
